import React from 'react';
import Error from 'next/error';

import {
  getKbArticles,
  getKBCategories,
  getKbArticlesByCategorySlug,
  findKbCategoryBySlug,
  getKbArticleBySlug,
} from '../src/lib/backend';
import KBPage from '../src/components/kb/KBPage';
import KBCategoryPage from '../src/components/kb/KBCategoryPage';
import Head from 'next/head';
import { getArticlesPage } from '../src/selectors/articles';
import KBArticlePage from '../src/components/kb/KBArticlePage';
import R from '../src/lib/routes';
import { NextSeo } from 'next-seo';
import { fallbackImageInfo, createFrontendPageUrl } from '../src/lib/selectors';
import i18n from '../src/translations/i18n';

const knowledgeBasePage = ({ kbCategory, kbArticle, data, error, ...passProps }) => {
  if (error) {
    return <Error statusCode={error.code} />;
  }

  return (
    <>
      <Head>
        <meta name="description" content={i18n.kbPageSEODescription} key="description" />
        <title>{i18n.kbPageSEOTitle}</title>
      </Head>
      <NextSeo
        openGraph={{
          url: createFrontendPageUrl(R.knowledgeBase),
          locale: 'en_US',
          title: i18n.kbPageSEOTitle,
          description: i18n.kbPageSEODescription,
          type: 'website',
          images: [fallbackImageInfo],
          site_name: i18n.kbpageSiteName,
        }}
      />
      {kbArticle ? (
        <KBArticlePage {...data} />
      ) : kbCategory ? (
        <KBCategoryPage {...data} {...passProps} />
      ) : (
        <KBPage {...data} {...passProps} />
      )}
    </>
  );
};

knowledgeBasePage.getInitialProps = async ({ query, session }) => {
  try {
    const categorySlug = query && query.categorySlug;
    const articleSlug = query && query.articleSlug;

    if (articleSlug) {
      const data = await getKbArticleBySlug(session, articleSlug);
      return {
        data,
        kbArticle: true,
      };
    }

    if (categorySlug) {
      const articles = await getKbArticlesByCategorySlug(session, categorySlug);
      const result = await findKbCategoryBySlug(session, categorySlug);

      return {
        kbCategory: true,
        data: {
          articles,
          category: result.category,
          prev: result.prev,
          next: result.next,
        },
      };
    }

    const categories = await getKBCategories(session);
    const page = getArticlesPage(R.knowledgeBase);
    const result = await getKbArticles(session, page);

    return {
      session,
      categories,
      data: {
        articles: result.items,
        page: result.page,
        totalPages: result.totalPages,
      },
    };
  } catch (error) {
    console.error('Failed to load Knowledge Base', error);
    return { error };
  }
};

export default knowledgeBasePage;
